import { Component } from '@angular/core';

@Component({
  selector: 'app-fcr24',
  templateUrl: './fcr24.component.html',
  styleUrl: '../../../../../../../../styles-tabelle-orari.css'
})
export class Fcr24Component {

}
